import { Col, Row, Table } from 'reactstrap';
import { ContentBlock } from '../../Shared/Content/ContentBlock';
import { ContentHeading } from '../../Shared/Content/ContentHeading';
import { ContentBody } from '../../Shared/Content/ContentBody';

export const Chargers = () => {
    return (
        <div id="chargers">
            <ContentBlock className="vehicleSummary">
                <ContentHeading title="Chargers" />
                <ContentBody>
                    <div className="heading5">All electric vehicles (EVs) require access to charging stations, especially in fleet applications. In this case, most of the charging is typically done at the fleet facility-overnight or between shifts. Facility-based charging can be supplemented with periodic charging at workplaces, idle locations, and public destinations. There are three main ways to charge an EV.</div>
                    <Row className="electrificationBasicsContent">

                        {/* Level 1 Chargers */}
                        <Row className="chargerTable surface9Border">
                            <Col lg={12} md={12} sm={12} className="chargerTableHeader surface9Background" >
                                Level 1 Chargers
                            </Col>
                            <Col lg={6} md={12} sm={12} className="chargerTableSummaryBox" >
                                <div className="evBasicsLevel1Charger backgroundImages"></div>
                                <div className="chargerTableSummaryContentBox">A Level 1 charger plugs directly into a household outlet on one end and into the vehicle's charge port on the other end. These chargers are the slowest category of electric vehicle supply equipment (EVSE).</div>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Charging time <br/>and range<sup className={'super-footnote'}>3</sup></Row>
                                <Row className="content">Fewer than 10 hours for a full charge with 2 to 5 miles of range added per hour</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox chargerTableLastBox" >
                                <Row className="header">Charging load (kWh)</Row>
                                <Row className="content">1.4-1.9 kW</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Voltage input (V)</Row>
                                <Row className="content">Use a standard 120 V AC plug, one-phase service with a three-prong electrical outlet</Row>
                            </Col>
                        </Row>

                        {/* Level 2 Chargers */}
                        <Row className="chargerTable batteryTwoBorder">
                            <Col lg={12} md={12} sm={12} className="chargerTableHeader batteryTwoBackground" >
                                Level 2 Chargers
                            </Col>
                            <Col lg={6} md={12} sm={12} className="chargerTableSummaryBox" >
                                <div className="evBasicsLevel2Charger backgroundImages"></div>
                                <div className="chargerTableSummaryContentBox">Level 2 charging equipment is common for home, public, and workplace charging. Most public chargers in the United States are Level 2. They can operate at up to 80 amperes (amps) and 19.2 kilowatts (kW) and provide faster charging than Level 1 EVSE.</div>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Charging time <br/>and range<sup className={'super-footnote'}>3</sup></Row>
                                <Row className="content">4 to 6 hours for a full charge with 10 to 20 miles of range added per hour</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox chargerTableLastBox" >
                                <Row className="header">Charging load (kWh)</Row>
                                <Row className="content">2-19.2 kW</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Voltage input (V)</Row>
                                <Row className="content">Use a 208 V (commercial) or 240 V (residential) AC split phase service</Row>
                            </Col>
                        </Row>

                        {/* Level 3 Chargers */}
                        <Row className="chargerTable accentTwoBorder">
                            <Col lg={12} md={12} sm={12} className="chargerTableHeader accentTwoBackground" >
                                DC Fast Chargers
                            </Col>
                            <Col lg={6} md={12} sm={12} className="chargerTableSummaryBox" >
                                <div className="evBasicsLevelDCFast backgroundImages"></div>
                                <div className="chargerTableSummaryContentBox">The fastest way to charge an EV is with a DC fast charger, which will typically add 75-150 miles of range for every 30 minutes the vehicle spends charging. The range of miles added depends on various factors, such the vehicle type and the capacity of the charger.</div>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Charging time <br/>and range<sup className={'super-footnote'}>3</sup></Row>
                                <Row className="content">About 30 minutes for a full charge with 60 to 80 miles of range added in 20 minutes of charging</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox chargerTableLastBox" >
                                <Row className="header">Charging load (kWh)</Row>
                                <Row className="content">50 kW+</Row>
                            </Col>
                            <Col lg={2} md={4} sm={12} className="chargerTableInfoBox" >
                                <Row className="header">Voltage input (V)</Row>
                                <Row className="content">Use 208 V or 480 V AC, three-phase service connection requiring a dedicated circuit</Row>
                            </Col>
                        </Row>

                        <div className="disclaimer">
                            <p><sup className={'super-footnote'}>3</sup>Exact times and charging range depend on the charger load specifications, circuit amperage, vehicle type, and size of the electric battery.</p>
                        </div>
                        <div className="referenceContent">
                            Learn more at <a href="https://www.fueleconomy.gov/" target="_blank" rel="noreferrer" >FuelEconomy.gov</a> and the <a href="https://afdc.energy.gov/vehicles/electric_basics_ev.html" target="_blank" rel="noreferrer" >Alternative Fuels Data Center.</a>
                        </div>
                    </Row>

                </ContentBody>
            </ContentBlock>
        </div>
    );

};
